// Canonical pattern list for virtual audio drivers (audio routers, not real
// hardware). Two consumers:
//   - suggestedNonContinuityMic.ts — filters candidates for the iPhone-mic
//     alert's "swap to a real device" suggestion.
//   - DeviceManager.ts — de-prioritizes these in the auto-pick during
//     listAndSelectDevices / forceRefreshDevices and in the deduplication
//     sort. Selecting one of these as the lobby default silently hands
//     audio to a routing app instead of a real mic, prompting users to
//     manually re-pick after meeting start.
//
// Adding a pattern here affects both consumers. Each entry's provenance:
//   - krisp, zoomaudiodevice, blackhole, loopback, soundflower, vb-cable
//     came from suggestedNonContinuityMic's original list (the iPhone-mic
//     alert's swap-target filter).
//   - vb-audio, eqmac, microsoft teams audio came from the auto-pick
//     de-prioritization fix (recurrence sweep 2026-05-04 displaced-from
//     labels: eqMac2 + CABLE-A from VB-Audio family + Microsoft Teams Audio).
//
// Convention: patterns are lowercased; the /i flag handles case folding.
// Don't camelCase new entries to "match the product name visually" —
// it's redundant given /i and creates drift between sibling pattern files.
export const VIRTUAL_AUDIO_LABEL_PATTERNS = [
  /krisp/i,
  /zoomaudiodevice/i,
  /blackhole/i,
  /loopback/i,
  /soundflower/i,
  /vb-cable/i,
  /vb-audio/i,
  // ^-anchored: eqMac is a known product name; do not match arbitrary
  // substrings like "MyEqMacRouter". Same convention as the
  // ^(iPhone|iPad)[\s\d]/i Continuity rule in DeviceManager.ts.
  /^eqmac/i,
  /microsoft teams audio/i,
];

export function isVirtualAudioDevice(device: MediaDeviceInfo): boolean {
  return VIRTUAL_AUDIO_LABEL_PATTERNS.some((p) => p.test(device.label ?? ""));
}
